import {initTPSubjectPage} from "TPEngine@2026/presentation/TPSubject";

await initTPSubjectPage();